import axios from 'axios';
import Vue from 'vue';
import {Toast} from 'vant';

export const http = axios.create({
  baseURL: process.env.NODE_API,
  //timeout: 10000,
  withCredentials: false
});

export function setAuthToken(token) {
  console.log('set auth token:', token);
  window.localStorage.setItem('sessionId', token);
}

export const AuthTokenHeader = 'X-Auth-Token';

export function getAuthTokenFromHeader(httpResponse) {
  return httpResponse.headers[AuthTokenHeader.toLowerCase()];
}

// 添加请求拦截器
http.interceptors.request.use(function (config) {
  let sessionId = window.localStorage.getItem('sessionId');
  if (sessionId) {
    config.headers[AuthTokenHeader] = sessionId;
  }
  return config;
});

http.interceptors.response.use(response => {
  return response;
}, error => {
  Vue.$hideLoading && Vue.$hideLoading();
  if (error.response && error.response.status === 403) {
    Toast('没有权限');
  } else if (error.config.url && !error.config.url.includes('userinfo') && !error.config.skipErrorToast) {
    Toast(`${error.config.url}请求失败：${error.response.data.message}`);
  }

  return Promise.reject(error);
});

Vue.prototype.$http = http;

//请假管理
export const leaveManage = {
  save(obj) {
    return http.post('/leave/add', obj);
  },
  //行政教师审批
  audit(obj) {
    return http.post('/leave/audit', obj);
  },
  batchAudit(obj) {
    return http.post('/leave/batch-audit', obj);
  },
  //任课教师审批
  courseTeacher(obj) {
    return http.post('/leave/courseAudit', obj);
  },
  queryDetail(params) {
    return http.get('/leave/detail', {params});
  },
  courseTeachList(params) {
    return http.get('/leave/course-tech-list', {params});
  },
  queryStuSelfRecords(params) {
    return http.get('/leave/student-list', {params});
  },
  queryTeacherRecords(params) {
    return http.get('/leave/tech-list', {params});
  },
  queryHelpTeacherStudentList() {
    return http.get('/leave/helperTeacherStudentList', {});
  },
  queryFdyList() {
    return http.get('/leave/fdyList', {});
  },
  teacherAdd(obj) {
    return http.post('/leave/teacherAdd', obj);
  },
  cancel(obj) {
    return http.post('/leave/cancel', obj);
  },
  fdyCancel(obj) {
    return http.post('/leave/fdyCancel', obj);
  },
  reselectFdy(obj) {
    return http.post('/leave/reselectFdy', obj);
  },
  publicLeaveList(params) {
    return http.get('/leave/publicLeaveList', {params});
  }
};

//假期管理
export const holidayManage = {
  add(obj) {
    return http.post('/holiday/add', obj);
  },
  delete(params) {
    return http.delete('/holiday/delete', {params});
  },
  getList(params) {
    return http.get('/holiday/list', {params});
  },
}
export const DataAnalyze = {
  queryList(params) {
    return http({
      url: '/stat/stu/user',
      params: params,
      timeout: 120000
    });
  }
};

export const AiHelper = {
  queryCallList(params) {
    return http.post('/ai-call/call-list', params);
  },
  batchSign(obj) {
    return http.post('/ai-call/teacherBatchMark', obj);
  },
  queryDetail(id) {
    return http.get(`/ai-call/call-detail/${id}`);
  }
};

export const Booking = {
  queryList() {
    return http.get('/booking/myList');
  },
  queryAllList() {
    return http.get('/booking/allList');
  },
  submitInOrder(obj) {
    return http.post('/booking/save', obj);
  },
  audit(obj) {
    return http.post('/booking/audit', obj);
  }
};

export const helpFriend = {
  queryMajorList(params) {
    return http.get('/major-list', {params});
  },
  submitInOrder(obj) {
    return http.post('/createInOrder', obj);
  },
  queryInOrderList() {
    return http.get('/inOrderList');
  },
  submitOutOrder(obj) {
    return http.post('/createOutOrder', obj);
  },
  queryOutOrderList() {
    return http.get('/outOrderList');
  },
  queryList() {
    return http.get('/orderList');
  },
  queryOutDetail(params) {
    return http.get('/outOrder', {params});
  },
  queryInDetail(params) {
    return http.get('/inOrder', {params});
  }
};

export const Course = resource('/course', http, {
  queryCheckList(obj) {
    return http.post('/checkIn/list', obj);
  },
  queryCheckHistoryList(obj) {
    return http.post('/checkIn/history-list', obj);
  },
  updateCheckList(obj) {
    return http.post('/checkIn/update-all', obj);
  },
  updateStuStatus(obj) {
    return http.post('/checkIn/update', obj);
  },
  createCheckCode(obj) {
    return http.post('/checkIn/create-code', obj);
  },
  signIn(params) {
    return http.get('/checkIn/code-check-in', {params});
  },
  valid(params) {
    return http.get('/checkIn/valid-code', {params});
  },
  queryCheckDetail(params) {
    return http.get('/checkIn/course-check-in-count', {params});
  },
  queryStuCheckDetail(params) {
    return http.get('/checkIn/stu-course-check-in-count', {params});
  },
  forceOutDate(params) {
    return http.get('/checkIn/delete-code', {params});
  },
  clearRecords(data) {
    return http.post('/checkIn/reset', data);
  },
  getValidCode() {
    return http.get('/checkIn/create-code-img', {params: {}, responseType: 'blob'});
  },
  evaluate(obj) {
    return http.post('/teacher-mark/save', obj);
  },
  queryDetail(params) {
    return http.get('/checkIn/stu-check-count', {params});
  },
  queryHelpTeacher(params) {
    return http.get('/course/helpTeacher', {params});
  }
});

export const User = resource('/login', http, {
  login(params = {}) {
    return http.get('/userinfo', {params});
  },
  loginDev(userId, password) {
    return http.post('/login/dev', {
      userId,
      password
    }, {
      skipErrorToast: true
    });
  },
  queryRoles() {
    return http.get('/role/self');
  }
});

export const AbsentWarn = {
  leaderTeacherList(params) {
    return http.get('/absentWarn/leaderTeacher/list', {params});
  },
  helpTeacherList(params) {
    return http.get('/absentWarn/helpTeacher/list', {params});
  },
  leaderTeacherRemark(params) {
    return http.post('/absentWarn/leaderTeacher/remark', params);
  },
  helpTeacherRemark(params) {
    return http.post('/absentWarn/helpTeacher/remark', params);
  },
  detail(params) {
    return http.get('/absentWarn/detail', {params});
  }
};

export const CourseAdjust = {
  add(params) {
    return http.post('/courseAdjust/add', params);
  },
  list(params) {
    return http.get('/courseAdjust/list', {params});
  },
  detail(params) {
    return http.get('/courseAdjust/detail', {params});
  },
  courseList(params) {
    return http.get('/courseAdjust/courseList', {params});
  },
  audit(params) {
    return http.post('/courseAdjust/audit', params);
  },
  auditList(params) {
    return http.get('/courseAdjust/auditList', {params});
  }
};

export const Oss = {
  upload(params) {
    return http.post('/oss/upload', params);
  }
};

export const Oauth = {
  login(params) {
    return http.post('/oauth/login', params);
  },
  changePassword(params) {
    return http.post('/oauth/changePassword', params);
  },
  wechatLoginUrl(params) {
    return http.get('/oauth/wechatLoginUrl', {params});
  },
  wechatBindUrl(params) {
    return http.get('/oauth/wechatBindUrl', {params});
  },
  wechatBind(params) {
    return http.post('/oauth/wechatBind', params);
  },
  wechatUnBind(params) {
    return http.post('/oauth/wechatUnBind', params);
  },
  wechatLogin(params) {
    return http.post('/oauth/wechatLogin', params);
  }
};

/**
 * create vue-resource's resource like object
 *
 * Default Actions
 *   get: {method: 'GET'}
 *   save: {method: 'POST'}
 *   query: {method: 'GET'}
 *   update: {method: 'PUT'}
 *   delete: {method: 'DELETE'}
 *
 * @param path the resource path
 * @param http axios instance
 * @param actions custom actions
 * @returns the resource object
 */
function resource(path, http, actions) {
  let obj = {
    get: id => http.get(path + '/' + id),
    save: obj => http.post(path, obj),
    query: params => http.get(path, {params}),
    update: (id, obj) => {
      let url = path + '/' + id;
      if (typeof (id) === 'object') {
        url = path;
        obj = id;
      }
      return http.put(url, obj);
    },
    delete: id => http.delete(path + '/' + id)
  };
  return Object.assign(obj, actions);
}
